// Phase 6.0 STEP C · 인기 공동구매 (Phase 5.9 group_buys 재사용 · 새 도메인 없음)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, ChevronRight, Flame } from 'lucide-react';
import api from '@/lib/api';

const won = (n) => `${(Number(n) || 0).toLocaleString('ko-KR')}원`;

export default function PopularGroupBuys() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('/public/home/group-buys?limit=6')
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoaded(true));
  }, []);

  if (loaded && items.length === 0) return null;

  return (
    <section className="py-8 sm:py-10 border-b border-black/5 dark:border-white/10 bg-gradient-to-b from-orange-50/40 to-white dark:from-orange-950/10 dark:to-[#0A0A0A]" data-testid="home-group-buys">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Flame className="text-[#FF3B30]" size={22}/>
            <h2 className="text-xl sm:text-2xl font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="group-buys-title">
              🤝 인기 공동구매
            </h2>
          </div>
          <Link to="/schedule" className="text-xs sm:text-sm font-bold text-[#FF3B30] hover:underline inline-flex items-center gap-0.5" data-testid="group-buys-viewall">
            전체보기 <ChevronRight size={14}/>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {items.map((gb) => {
            const target = Number(gb.target) || 0;
            const count = Number(gb.current_count) || 0;
            const pct = target > 0 ? Math.min(100, Math.round((count / target) * 100)) : 0;
            const savedPct = gb.base_price > 0
              ? Math.max(0, Math.round(((gb.base_price - gb.current_price) / gb.base_price) * 100))
              : 0;
            return (
              <Link key={gb.group_buy_id} to={`/product/${gb.product_id}`}
                className="rounded-2xl overflow-hidden border border-black/10 dark:border-white/10 bg-white dark:bg-[#141414] hover:shadow-lg hover:-translate-y-0.5 transition-all"
                data-testid={`gb-card-${gb.group_buy_id}`}>
                <div className="relative aspect-square bg-gray-100 dark:bg-white/5 overflow-hidden">
                  {gb.product_image && (
                    <img src={gb.product_image} alt={gb.product_name}
                      className="absolute inset-0 w-full h-full object-cover"/>
                  )}
                  <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full bg-[#FF3B30] text-white text-[10px] font-black inline-flex items-center gap-0.5">
                      <Users size={10}/> 공구
                    </span>
                    {gb.status === 'target_reached' && (
                      <span className="px-2 py-0.5 rounded-full bg-emerald-500 text-white text-[10px] font-black">목표달성</span>
                    )}
                  </div>
                  {savedPct > 0 && (
                    <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-full bg-black/80 text-white text-[10px] font-black">
                      -{savedPct}%
                    </span>
                  )}
                </div>
                <div className="p-3">
                  <p className="text-[10px] text-gray-500 truncate mb-0.5">{gb.seller_name || '판매자'}</p>
                  <p className="text-sm font-bold truncate mb-1">{gb.product_name}</p>
                  <div className="flex items-baseline gap-1.5 mb-2">
                    <span className="text-base font-black text-[#FF3B30]" style={{ fontFamily: 'Manrope, sans-serif' }}>{won(gb.current_price)}</span>
                    {gb.base_price > gb.current_price && (
                      <span className="text-[10px] line-through text-gray-400">{won(gb.base_price)}</span>
                    )}
                  </div>
                  {/* Progress bar */}
                  <div className="h-1.5 rounded-full bg-black/5 dark:bg-white/10 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-[#FF3B30] to-[#FF9F0A]" style={{ width: `${pct}%` }}/>
                  </div>
                  <div className="flex items-center justify-between mt-1 text-[10px]">
                    <span className="font-bold text-[#FF3B30]">{count}/{target || '?'}명 참여</span>
                    <span className="text-gray-500">{pct}% 달성</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
